import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Observable, throwError, of } from 'rxjs';
import { retry, catchError, map, tap } from 'rxjs/operators';
import { LocalStorage } from 'ngx-store';
import { Booking } from './addbooking/booking.interface';
import { WhCsvBooking } from './importbookings/whbooking.interface';
import * as moment from "moment";
import { ConnoteDocuments,Rate } from 'src/app/model/connotedocuments.model';
import { Url, User } from '../../model/users.model';
import { NotificationsSettingsService } from '../../services/notificationssettings.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class BookingsServicev2 {
    @LocalStorage() url: Url;
    @LocalStorage() user: User;
    // Http Headers
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    constructor(public http:HttpClient, private svc_notif_settings: NotificationsSettingsService) {
    }

    getConnotesv2(statusFilter, dateFilter, start, end, offset, limit): Observable<any> {
        var param = '';
        let status = statusFilter?statusFilter:0;
        let date = dateFilter?dateFilter:0;
        let from = start?start:0;
        let to = end?end:0;

        param = '/'+status+'/'+date+'/'+from+'/'+to+'/'+offset+'/'+limit;
        console.log('param ', param);

        //-> to include "param" in the request
        // return this.http.get<any>('http://127.0.0.1:8000/tms/getConnotesv2' + param, this.httpOptions)
        return this.http.get<any>(this.url.rest + '/tms/getConnotesv2' + param, this.httpOptions)
            .pipe(
                // retry(1),
                catchError(this.handleError)
            );
    }

    getStates(){
        // return this.http.get<any>('http://127.0.0.1:8000/tms/getStatesv2', this.httpOptions)
        return this.http.get<any>(this.url.rest + '/tms/getStatesv2', this.httpOptions)
            .pipe(
                // retry(1),
                catchError(this.handleError)
            );
    }

    // Error handling
    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }
}